import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCharacter } from '@/hooks/useCharacter';

export function StateBadge(): JSX.Element | null {
  const character = useCharacter();
  const navigate = useNavigate();
  const [timeLeft, setTimeLeft] = useState('');

  const state = character?.state;
  const until = character?.state_until;
  const isActive = state === 'jail' || state === 'hospital';

  useEffect(() => {
    if (!isActive || !until) return;
    const target = new Date(until).getTime();

    function update(): void {
      const diff = target - Date.now();
      if (diff <= 0) {
        setTimeLeft('0:00');
        return;
      }
      const mins = Math.floor(diff / 60000);
      const secs = Math.floor((diff % 60000) / 1000);
      setTimeLeft(`${mins}:${secs.toString().padStart(2, '0')}`);
    }

    update();
    const interval = setInterval(update, 1000);
    return () => clearInterval(interval);
  }, [isActive, until]);

  if (!isActive) return null;

  const isJail = state === 'jail';

  return (
    <button
      type="button"
      onClick={() => navigate('/crimes')}
      className="fixed top-2 left-1/2 -translate-x-1/2 z-[60] inline-flex items-center gap-2 rounded-full border-2 border-blood-bright/60 bg-sea-deep/95 backdrop-blur-sm px-4 py-1.5 text-sm text-parchment shadow-[0_2px_12px_rgba(0,0,0,0.5)] hover:border-blood-bright transition-colors"
    >
      <span>{isJail ? '\u{1F512}' : '\u{1F3E5}'}</span>
      <span className="font-display uppercase tracking-wider text-xs">
        {isJail ? 'Jail' : 'Hospital'}
      </span>
      <span className="font-mono text-blood-bright">{timeLeft}</span>
    </button>
  );
}
